import React from "react";
import CardsComponent from "../../components/CardsComponent";
import CarouselItems from "../../components/CarousalItems";
import Testimonials from "../../components/Testimonials";
import HeroSection from "../../components/HeroSection";
import LogoCarousel from "../../components/LogoCarousal";
import VideoComponent from "../../components/VideoComponent";
import MFDetails from "../../components/MFDetails";
import StatsComponent from "../../components/StatsComponent";
import CaseStudies from "../../components/CaseStudies";

import { motion } from "framer-motion";

function Home() {
  return (
    <>
      <VideoComponent />
      <MFDetails />
      {/* <CardsComponent /> */}
      {/* <HeroSection {...homeObjOne} /> */}
      {/* <CarouselItems /> */}
      {/* <Stepper /> */}
      {/* <Fade bottom>
        <StatsComponent />
      </Fade>*/}
      <LogoCarousel /> 
      {/* <Testimonials /> */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <CaseStudies />
      </motion.div>
    </>
  );
}

export default Home;
